import { render, staticRenderFns } from "./m-dialog-confirmation.vue?vue&type=template&id=45c873a4&scoped=true&lang=pug&"
import script from "./m-dialog-confirmation.vue?vue&type=script&lang=js&"
export * from "./m-dialog-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./m-dialog-confirmation.vue?vue&type=style&index=0&id=45c873a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c873a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
